import * as React from 'react';

import AccessibleSVG from '../accessible-svg';
import { TwoTonedIcon } from '../iconTypes';

const IconMetadataSwitch = ({ className = '', height = 16, title, width = 16 }: TwoTonedIcon) => (
    <AccessibleSVG
        className={`metadata-switch ${className}`}
        height={height}
        title={title}
        viewBox="0 0 16 16"
        width={width}
    >
        <path d="M8.82929429,12 C8.93984578,11.6872211 9,11.3506354 9,11 C9,10.6493646 8.93984578,10.3127789 8.82929429,10 L15,10 C15.5522847,10 16,10.4477153 16,11 C16,11.5522847 15.5522847,12 15,12 L8.82929429,12 Z M3.17070571,12 L1,12 C0.44771525,12 0,11.5522847 0,11 C0,10.4477153 0.44771525,10 1,10 L3.17070571,10 C3.06015422,10.3127789 3,10.6493646 3,11 C3,11.3506354 3.06015422,11.6872211 3.17070571,12 Z M13.8292943,6 C13.9398458,5.68722107 14,5.35063542 14,5 C14,4.64936458 13.9398458,4.31277893 13.8292943,4 L15,4 C15.5522847,4 16,4.44771525 16,5 C16,5.55228475 15.5522847,6 15,6 L13.8292943,6 Z M8.17070571,6 L1,6 C0.44771525,6 0,5.55228475 0,5 C0,4.44771525 0.44771525,4 1,4 L8.17070571,4 C8.06015422,4.31277893 8,4.64936458 8,5 C8,5.35063542 8.06015422,5.68722107 8.17070571,6 Z M9,5 C9,3.8954305 9.8954305,3 11,3 C12.1045695,3 13,3.8954305 13,5 C13,6.1045695 12.1045695,7 11,7 C9.8954305,7 9,6.1045695 9,5 Z M4,11 C4,9.8954305 4.8954305,9 6,9 C7.1045695,9 8,9.8954305 8,11 C8,12.1045695 7.1045695,13 6,13 C4.8954305,13 4,12.1045695 4,11 Z" />
    </AccessibleSVG>
);

export default IconMetadataSwitch;
